// @ts-nocheck



import { createSlice } from '@reduxjs/toolkit';



import { fuelAndOilApi } from './../lib/api';

export const FETCH_FUEL_AND_OIL = '/vehicles/fuelAndOil/fetch';
export const UPDATE_FUEL_AND_OIL = '/vehicles/fuelAndOil/update';
export const CLEAN_FUEL_AND_OIL = '/vehicles/fuelAndOil/clean';



const initialState = null;

const fuelAndOilSlice = createSlice({
  name: '/vehicles/fuelAndOil',
  initialState,
  reducers: {
    fetch: (state, { payload }) => ({
      ...payload
    }),
    update: (state, { payload }) => ({
      ...payload
    }),
    clean: () => null
  }
});

export const fuelAndOilActions = fuelAndOilSlice.actions;

export const addFuelAndOil = (fuelAndOil) => async (
dispatch) =>
{
  await fuelAndOilApi.addFuelAndOil(fuelAndOil);
};

// Обновление данных
export const updateFuelAndOil = (fuelAndOil) => async (
dispatch) =>
{
  const updated = await fuelAndOilApi.updateFuelAndOil(fuelAndOil);
  dispatch(fuelAndOilActions.update({ ...updated }));
};

// Удаление
export const deleteFuelAndOil = (id) => async (dispatch) => {
  await fuelAndOilApi.deleteFuelAndOil(id);
};

// Подгрузка ГСМ
export const fetchFuelAndOil = (id) => async (dispatch) => {
  const fuelAndOil = await fuelAndOilApi.fetchFuelAndOil(id);
  dispatch(fuelAndOilActions.fetch({ ...fuelAndOil }));
};

export const cleanFuelAndOil = () => (dispatch) => {
  dispatch(fuelAndOilActions.clean());
};

export default fuelAndOilSlice.reducer;
